import { Typography } from 'components/generic/typography';
import styled from 'styled-components';

const StyledBody = styled(Typography.Body)`
    margin-block-end: 1em;

    // Prevents the editor from using paragraphs as line-breaks
    &:empty {
        display: none;
    }

    &:last-child {
        margin-block-end: 0;
    }
`;

const StyledHeadline = styled(Typography.Headline)`
    margin-block-end: 0.25em;
`;

const StyledTitle = styled(Typography.Title)`
    margin-block-end: 0.25em;
`;

export { StyledBody, StyledHeadline, StyledTitle };
